<script lang="ts">
    
    import { navigate } from "svelte-navigator";
    import Button from "../Components/Shared/Button.svelte";
    import InputText from "../Components/Shared/InputText.svelte";
    import Slide from "../Components/Shared/Slide.svelte";
    import Slider from "../Components/Shared/Slider.svelte";
    import Sprite from "../Components/Shared/Sprite.svelte";
    import View from "../Components/Shared/View.svelte";
    import { players } from "../Game/players";
    import { playerFactory } from "../Services/playerFactory";
    import { setPlayer } from "../Services/playerRepository";
    import { clearGameDates, clearPoints, clearTarget, hasSavedGame, saveGame, setCheckpointAsTarget, setStartGameDate } from "../Services/game";
    import { gameFactory } from "../Services/gameFactory";
    import { gameDefaults } from "../Game/game";

    let selectedIndex = 0;
    let playerName = players[selectedIndex].name;
    
    $: canStart = selectedIndex !== undefined && !!playerName;

    function onAvatarSelect({ detail: index }: CustomEvent<number>): void {
        selectedIndex = index;
        playerName = players[index].name;
    }

    function onStart(): void {
        if (!canStart) {
            return;
        }
        const { preview, chatImage, sprite } = players[selectedIndex];
        const player = playerFactory(playerName, preview, chatImage, sprite);
        setPlayer(player);
        navigate('/game');
    }

</script>

<View mainBackground flex>
    <div class="player-config">
        <div class="avatar-selection">
            <h2 class="section-title">Elige un avatar</h2>
            <div class="avatars">
                <Slider on:change={onAvatarSelect}>
                    {#each players as player, index}
                        <Slide>
                            <Sprite src={player.sprite} animation="walk_se" play={selectedIndex === index} />
                        </Slide>
                    {/each}
                </Slider>
            </div>
        </div>
    
        <div class="name-selection">
            <h2 class="section-title">Introduce un nombre</h2>
            <div class="name-control">
                <InputText bind:value={playerName} />
            </div>
        </div>

        <div class="start-game">
            <Button on:click={onStart} disabled={!canStart}>Empezar</Button>
        </div>
    </div>
</View>

<style lang="scss">

    .player-config {
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .section-title {
        text-align: center;
    }

    .name-control {
        display: flex;
        justify-content: center;
    }

    .name-selection {
        padding: 2rem 0;
    }

    .start-game {
        display: flex;
        justify-content: center;
    }

</style>
